import { IWorkspace } from '@dataplace.ai/types'

export const getUserPermissionType = (workspaces: IWorkspace[], workspaceId: string) : string | undefined =>
  workspaces?.find(workspace => workspace?.workspaceId === workspaceId)?.permissionType
